import { Product, Options } from '../types/product';

export function getOptionsForProduct(selectedProduct: Product): React.SetStateAction<Options[]> {
  return selectedProduct?.options.map((_option, index) => {
    return {
      values: [...new Set(selectedProduct?.variants.map(({ options }) => {
        return options[index];
      }))],
      name: selectedProduct?.options[index],
      position: index + 1,
    };
  });
}
